'use strict';
/**
 * Module dependenices
 */ var clone = require('shallow-clone');
var typeOf = require('kind-of');
var isPlainObject = require('is-plain-object');
function cloneDeep(val, instanceClone) {
    switch(typeOf(val)){
        case 'object':
            return cloneObjectDeep(val, instanceClone);
        case 'array':
            return cloneArrayDeep(val, instanceClone);
        default:
            {
                return clone(val);
            }
    }
}
function cloneObjectDeep(val, instanceClone) {
    if (typeof instanceClone === 'function') {
        return instanceClone(val);
    }
    if (instanceClone || isPlainObject(val)) {
        var res = new val.constructor();
        for(var key in val){
            res[key] = cloneDeep(val[key], instanceClone);
        }
        return res;
    }
    return val;
}
function cloneArrayDeep(val, instanceClone) {
    var res = new val.constructor(val.length);
    for(var i = 0; i < val.length; i++){
        res[i] = cloneDeep(val[i], instanceClone);
    }
    return res;
}
/**
 * Expose `cloneDeep`
 */ module.exports = cloneDeep;
